// extracted by mini-css-extract-plugin
module.exports = {"root":"AddressModal_root__mUnoM","headline":"AddressModal_headline__DaEjO"};